import { render, staticRenderFns } from "./GCompanyInfo.vue?vue&type=template&id=063b0f67&scoped=true&"
import script from "./GCompanyInfo.vue?vue&type=script&lang=ts&"
export * from "./GCompanyInfo.vue?vue&type=script&lang=ts&"
import style0 from "./GCompanyInfo.vue?vue&type=style&index=0&id=063b0f67&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063b0f67",
  null
  
)

export default component.exports